import axios from "axios"
import dayjs from "dayjs"
import {omit} from "lodash"
import {normalize} from "normalizr"
import {INTERVENANTS_ENDPOINTS} from "../../../constants/endpoints"
import {getErrorMessage} from "../../../services/api"
import {getPageNumber} from "../../../services/pagination"
import {buildUrlSearchParams} from "../../../services/urlSearchParams"
import {
    GET_REFUNDS_OF_INTERVENANT_FAILURE,
    GET_REFUNDS_OF_INTERVENANT_REQUEST,
    GET_REFUNDS_OF_INTERVENANT_SUCCESS,
} from "./refundsActionTypes"
import * as schema from "./refundsSchema"

/**
 * Used to sort field in table
 */
const historyRefundBackEndField = {
    channel: "acheminement",
    dateFrom: "dateDebut",
    dateTo: "dateFin",
    id: "id",
    number: "numeroRemise",
    refundDate: "dateRemise",
    refundNumber: "numeroRemise",
    refundPayment: "datePaiement",
    refundState: "etatRemise",
    titleCount: "nombreTitre",
    totalAmount: "montantTotal",
    track: "circuit",
}

export const getBackEndField = accessor => historyRefundBackEndField[accessor]

/**
 * Thunk to get the list of refunds of the intervenant by providing the page number
 * Dispatch on request and on success or failure.
 */
export const getRefundsOfIntervenant =
    (page, sortedField, sortDirection, limit = 10, searchFormValues = {}) =>
    dispatch => {
        dispatch({
            type: GET_REFUNDS_OF_INTERVENANT_REQUEST,
        })

        const searchParams = [
            {
                fieldName: getBackEndField("dateFrom"),
                value: searchFormValues.dateFrom
                    ? dayjs(searchFormValues.dateFrom, "DD/MM/YYYY").format("DD/MM/YYYY HH:mm:ss")
                    : searchFormValues.dateFrom,
            },
            {
                fieldName: getBackEndField("dateTo"),
                value: searchFormValues.dateTo
                    ? dayjs(searchFormValues.dateTo, "DD/MM/YYYY").format("DD/MM/YYYY HH:mm:ss")
                    : searchFormValues.dateTo,
            },
            {fieldName: getBackEndField("number"), value: searchFormValues.number},
            {fieldName: getBackEndField("track"), value: searchFormValues.refundTrack},
            {fieldName: getBackEndField("channel"), value: searchFormValues.refundChannel},
        ]

        const params = {
            page,
            tri: sortedField + "," + sortDirection,
            taille: limit,
            recherche: buildUrlSearchParams(searchParams),
        }

        return axios.get(INTERVENANTS_ENDPOINTS.retrieveRefunds, {params}).then(
            response => {
                let pagination = omit(response.data, ["content"])
                dispatch({
                    type: GET_REFUNDS_OF_INTERVENANT_SUCCESS,
                    response: normalize(
                        response.data.content.map(refund => ({
                            id: refund.id,
                            refundDate: refund.dateRemise,
                            refundPayment: refund.circuit === "CRCESU" ? "Consulter le CRCESU" : refund.datePaiement,
                            refundNumber: refund.numeroRemise,
                            track: refund.circuit,
                            channel: refund.acheminement,
                            titleCount: refund.nombreTitre,
                            totalAmount: parseFloat(refund.montantTotal).toFixed(2),
                            refundState: refund.circuit === "CRCESU" ? "Consulter le CRCESU" : refund.etatRemise,
                            isBillDownloadable:
                                refund.numeroAcheminement === 1 ||
                                refund.numeroAcheminement === 2 ||
                                refund.numeroAcheminement === 3,
                        })),
                        schema.arrayOfRefunds,
                    ),
                })
                pagination = {
                    ...pagination,
                    maxPages: pagination.totalPages,
                    totalResults: pagination.totalElements,
                    number: getPageNumber(pagination.number),
                }

                return Promise.resolve(pagination)
            },
            error => {
                dispatch({
                    type: GET_REFUNDS_OF_INTERVENANT_FAILURE,
                    message: getErrorMessage(error),
                })
                return Promise.reject(error)
            },
        )
    }
